import { FuelTag } from '@frete.com/fuel-react';
import React from 'react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import AutoCompleteListItem from '../Item/AutoCompleteListItem';
import * as Styled from './AutoCompleteListStyles';
import {
  AutoCompleteListPropsInterface,
  SuggestionInterface,
} from './AutoCompleteListTypes';

function AutoCompleteList<T>({
  name,
  suggestionsList,
  onSelectSuggestion,
  searchTerm,
  activeIndex,
  leftIcon,
  rightIcon,
  emptyMessage,
  rightTagText = null,
  rightPrefixText = null,
  blockListMode = false,
}: AutoCompleteListPropsInterface<T>) {
  const match = (value: string) => {
    const escapeNonRegexp = /[-/\\^$*+?.()|[\]{}]/g;
    return new RegExp(`^(${value.replace(escapeNonRegexp, '\\$&')})?(.*)`, 'i');
  };

  const getItemList = (suggestion: SuggestionInterface<T>) => {
    let groupsTwo: string[] = [];
    let groupsData: string[] = [];

    const canShowTag = Boolean(rightTagText) && 'active' in suggestion;

    const Tag = canShowTag && (
      <Styled.Span>
        <FuelTag
          style={{ whiteSpace: 'pre' }}
          uppercase
          label={
            suggestion.active ? rightTagText?.positive : rightTagText?.negative
          }
        />
      </Styled.Span>
    );

    if (!searchTerm) {
      return (
        <Styled.WrapperInfo>
          <Styled.InfoLeft>
            <Styled.Description>{suggestion.description}</Styled.Description>
            <Styled.InfoBottom>
              <Styled.Span>{suggestion.subdescription}</Styled.Span>
            </Styled.InfoBottom>
          </Styled.InfoLeft>
          <FuelFlex
            defaultProps={{ alignItems: 'flex-end', flexDirection: 'column' }}
          >
            {Tag}
            <Styled.InfoBottom>
              <Styled.Prefix> {rightPrefixText}</Styled.Prefix>
              <Styled.Information>
                {suggestion.complementaryInformation}
              </Styled.Information>
            </Styled.InfoBottom>
          </FuelFlex>
        </Styled.WrapperInfo>
      );
    }

    const groups = match(searchTerm).exec(
      suggestion.description,
    ) as Array<string>;

    if (suggestion.subdescription) {
      groupsTwo = match(searchTerm).exec(suggestion.subdescription) as string[];
    }

    if (suggestion.complementaryInformation) {
      groupsData = match(searchTerm).exec(
        suggestion.complementaryInformation,
      ) as string[];
    }

    if (suggestion.subdescription && suggestion.complementaryInformation) {
      return (
        <Styled.WrapperInfo>
          <Styled.InfoLeft>
            <Styled.Strong>{groups[1]}</Styled.Strong>
            <Styled.Description>{groups[2]}</Styled.Description>
            <Styled.InfoBottom>
              <Styled.Strong>{groupsTwo[1]}</Styled.Strong>
              <Styled.Span>{groupsTwo[2]}</Styled.Span>
            </Styled.InfoBottom>
          </Styled.InfoLeft>
          <FuelFlex
            defaultProps={{ alignItems: 'flex-end', flexDirection: 'column' }}
          >
            {Tag}
            <Styled.InfoBottom>
              <Styled.Prefix> {rightPrefixText}</Styled.Prefix>
              <Styled.Information> {groupsData[1]}</Styled.Information>
              <Styled.Information> {groupsData[2]}</Styled.Information>
            </Styled.InfoBottom>
          </FuelFlex>
        </Styled.WrapperInfo>
      );
    }

    if (suggestion.subdescription) {
      return (
        <Styled.WrapperInfo>
          <Styled.InfoLeft>
            <Styled.Strong>{groups[1]}</Styled.Strong>
            <Styled.Description>{groups[2]}</Styled.Description>
            <Styled.InfoBottom>
              <Styled.Strong>{groupsTwo[1]}</Styled.Strong>
              <Styled.Span>{groupsTwo[2]}</Styled.Span>
            </Styled.InfoBottom>
          </Styled.InfoLeft>
          <FuelFlex
            defaultProps={{ alignItems: 'flex-end', flexDirection: 'column' }}
          >
            {Tag}
          </FuelFlex>
        </Styled.WrapperInfo>
      );
    }

    if (suggestion.complementaryInformation) {
      return (
        <Styled.WrapperInfo>
          <Styled.InfoLeft>
            <Styled.Strong>{groups[1]}</Styled.Strong>
            <Styled.Description>{groups[2]}</Styled.Description>
          </Styled.InfoLeft>
          <FuelFlex
            defaultProps={{ alignItems: 'flex-end', flexDirection: 'column' }}
          >
            {Tag}
            <Styled.Prefix> {rightPrefixText} </Styled.Prefix>
            <Styled.Information> {groupsData[2]} </Styled.Information>
          </FuelFlex>
        </Styled.WrapperInfo>
      );
    }

    return (
      <Styled.WrapperInfo>
        <Styled.InfoLeft>
          <Styled.Strong>{groups[1]}</Styled.Strong>
          <Styled.Span>{groups[2]}</Styled.Span>
        </Styled.InfoLeft>

        <FuelFlex
          defaultProps={{ alignItems: 'flex-end', flexDirection: 'column' }}
        >
          {Tag}
        </FuelFlex>
      </Styled.WrapperInfo>
    );
  };

  return (
    <Styled.List>
      {suggestionsList.length ? (
        suggestionsList.map((suggestion, index) => (
          <AutoCompleteListItem
            data-testid={name}
            key={`${name}-${suggestion.description}`}
            leftIcon={leftIcon}
            rightIcon={rightIcon}
            blockListMode={blockListMode}
            onMouseDown={() => onSelectSuggestion(suggestion)}
            active={index === activeIndex}
          >
            {/* TODO: Toda essa lógica para fazer o getItemList está atrelada a regra
            de negócio do frete, não do autocomplete e é necessário refatorar  */}
            {getItemList(suggestion)}
          </AutoCompleteListItem>
        ))
      ) : (
        <AutoCompleteListItem data-testid={name}>
          <Styled.Strong>{emptyMessage}</Styled.Strong>
        </AutoCompleteListItem>
      )}
    </Styled.List>
  );
}

export default AutoCompleteList;
